import { PathwayCard } from '@cpd-app/generated';
import { createAction, props } from '@ngrx/store';

export const loadPathwayCards = createAction(
  '[Pathway Cards] Load Pathway Cards'
);

export const loadPathwayCardsSuccess = createAction(
  '[Pathway Cards] Load Pathway Cards Success',
  props<{ pathwayCards: PathwayCard[] }>()
);

export const loadPathwayCardsError = createAction(
  '[Pathway Cards] Load Pathway Cards Error'
);
